
const Nosotros = () => {
  return (
    <div>Nosotros</div>
  )
}

export default Nosotros